import React from "react";
import { observer } from "mobx-react";
import { EditionTypeCreateStore } from "../../store";
import { EditionTypeCreateForm } from "./EditionTypeCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type EditionTypeCreateProps = {
  editionTypeCreateStore: EditionTypeCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EditionTypeCreate: React.FC<EditionTypeCreateProps> = observer(
  ({ editionTypeCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={editionTypeCreateStore.isSaving} />
        <EditionTypeCreateForm
          editionTypeCreateStore={editionTypeCreateStore}
          name_esError={editionTypeCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            editionTypeCreateStore.setName_esValue(value);
          }}
          name_es={editionTypeCreateStore.entityValues.name_es}
          name_enError={editionTypeCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            editionTypeCreateStore.setName_enValue(value);
          }}
          name_en={editionTypeCreateStore.entityValues.name_en}
          name_ptError={editionTypeCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            editionTypeCreateStore.setName_ptValue(value);
          }}
          name_pt={editionTypeCreateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={editionTypeCreateStore.isProcessing}
          onSave={() => editionTypeCreateStore.saveNewEditionType()}
          onCancel={() => editionTypeCreateStore.cancelNewEditionType()}
        />
        <ErrorDialog
          open={editionTypeCreateStore.errorDialogOpened}
          title={editionTypeCreateStore.errorTitle}
          description={editionTypeCreateStore.errorDescription}
          onClose={() => editionTypeCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
